export default __webpack_public_path__ + "static/media/MINUSCA_UN_staff_radio_guira_FM.2f8dc7bf.jpg";